import {ERegistrationType} from 'src/containers/LeadCompanyClients/definitions';

import {EBillingStatus} from './definitions';

export default {
  title: 'Company clients',
  searchPlaceholder: 'Quick search by company, TIN or login',
  unknownCompanyName: 'Company name is required',
  th: {
    createdAt: 'Created at',
    company: 'Company',
    taxNumber: 'TIN',
    login: 'Login',
    status: 'Status',
  },
  queryError: {
    title: 'Oops :(',
    subtitle: "We couldn't find your client because there are special characters in your search",
    hint: 'Try searching without them',
  },
  filters: {
    title: 'Filters',
    statusLabel: 'Registration status',
    createdAtLabel: 'Client registration date',
    managerLabel: 'Responsible manager',
    managerPlaceholder: 'Select a manager',
    resellerLabel: 'Jurisdiction',
    resellerPlaceholder: 'Select a jurisdiction',
    supportClients: 'Clients',
    tenantStatus: 'Client status',
    channels: 'Tenant channels',
    licenseStatus: 'License status',
    registrationType: 'Registration type',
    registrationTypes: {
      [ERegistrationType.SELF_SERVICE]: 'Self-service',
      [ERegistrationType.ADMIN_CREATED]: 'Admin created',
    },
    billing: 'Billing',
    billingStatus: {
      [EBillingStatus.ON]: 'Billing is enabled',
      [EBillingStatus.OFF]: 'Billing is disabled',
    },
    documentType: 'Document type',
  },
};
